import Resolution from 'engine/Resolution.js';
import {ROOM_NAME} from 'socket/constants.js';
import StepData from 'pattern/StepData.js';

class BaseAction {
    constructor(sequencerEngine) {
        this.sequencerEngine = sequencerEngine;
    }

    get state() {
        return this.sequencerEngine.state;
    }

    // Implemented in sub-classes
    execute() {}

    // Implemented in sub-classes
    undo() {}
        
    get roomName() {
        // todo: make this check for what room
        // you're in
        return ROOM_NAME;
    }
    serialize(action, id) {
        let json = {... action};
        json.payload = {... json.payload};
        if (json.payload.track) {
            // can't send the whole track so just get the trackNumber
            if (json.payload.track.subSequence) {
                json.payload.subSequence = json.payload.track.subSequence.id;
            }
            json.payload.track = json.payload.track.trackNumber;
        }

        // we want to attach a contentId that we use to later group actions
        // of the same type, together
        json.contentId = this.getContentId(action);

        return {
            type: "operation",
            operation: {
                ...json,
                uuid: id,
                timestamp: Date.now()
            },
        };
    }

    deserialize(json) {
        let payload = {... json.payload};
        if (payload.track !== undefined) {
            if (payload.subSequence !== undefined) {
                let subSequence = this.sequencerEngine.getSubSequence(payload.subSequence);
                if (subSequence) {
                    payload.track = subSequence.tracks[json.payload.track];
                }
            } else {
                payload.track = this.sequencerEngine.tracks[json.payload.track];
            }
        } 

        if (json.payload.resolution) {
            payload.resolution = new Resolution()
                .fromJson(json.payload.resolution);
        }
        
        return {
            ... json,
            payload
        };
    }

    deserializeStep(json, track, stepNumber) {
        var stepData = new StepData();
        stepData.track = track;
        stepData.stepNumber = stepNumber;
        stepData.loadFromJson(
            json,
            track.effects,
            undefined,
            undefined,
            undefined,
            track,
            track.midiEffects);
        stepData.id = json.id;

        return stepData;
    }

    getStepLocations(pattern, steps, usePosition) {
        let stepNumbers = pattern.getStepNumbers(steps);
        let stepLocations = [];
        for (let i in stepNumbers) {
            let step = stepNumbers[i][0];
            stepLocations.push({
                id: step.id,
                transpose: step.transpose,
                stepNumber: usePosition ? stepNumbers[i][1] + step.position : stepNumbers[i][1]
            });
        }
        return stepLocations;
    }

    getStepsForStepNumbers(stepAndStepNumbers, track) {
        let pattern = track.getEasyPattern();
        let resolvedSteps = [];
        for (let i in stepAndStepNumbers) {
            let step = stepAndStepNumbers[i];
            let steps = pattern.getAllSteps();
            let resolvedStep = steps
                .find(possibleStep => possibleStep.id === step.id);
            
            if (resolvedStep) {
                resolvedSteps.push(resolvedStep);
            }
        }
        return resolvedSteps;
    }

    sleep(time) {
        return new Promise(async (resolve) => {
            setTimeout(resolve, time);
        });
    }

    getContentId() {
        return 0;
    }

    getDependentActions() {
        return [];
    }
    
    dependsOn(type) {
        return this.getDependentActions().indexOf(type) > -1;
    }

    conflictsWith(actionA, actionB) {
        return this.dependsOn(actionB.type) &&
            actionA.contentId === actionB.contentId;
    }
}

export default BaseAction;
